export const mauIn = {
  titles: {
    list: 'Mẫu in',
    edit: 'Chỉnh sửa mẫu in',
    hoaDon: 'Mẫu in hóa đơn',
  },
  subtitle: 'Mỗi màn hình có bộ mẫu in và trường dữ liệu riêng',
  screens: {
    title: 'Màn hình',
    groups: {
      giaoDich: 'Giao dịch',
      soQuy: 'Sổ quỹ',
      kho: 'Kho',
      giaoHang: 'Giao hàng',
    },
    items: {
      'hoa-don': 'Hóa đơn',
      'hoa-don-ycsc': 'Hóa đơn SC',
      'tra-hang': 'Trả hàng',
      'dat-hang': 'Đặt hàng',
      'yeu-cau-sua-chua': 'Sửa chữa',
      'phieu-thu': 'Phiếu thu',
      'phieu-chi': 'Phiếu chi',
      'phieu-nhap-kho': 'Nhập kho',
      'phieu-xuat-kho': 'Xuất kho',
      'chuyen-hang': 'Chuyển HH',
      'phieu-nhan-hang': 'Nhận hàng',
      'kiem-ke': 'Kiểm kê',
      'tem-hang-hoa': 'Tem HH',
      'nhan-giao-hang': 'Nhãn GH',
    },
  },
  tabs: {
    pdf: 'PDF',
    excel: 'Excel',
  },
  sections: {
    header: 'Thông tin đầu trang',
    body: 'Thông tin hóa đơn',
    table: 'Bảng hàng hóa',
    totals: 'Tổng tiền',
    signature: 'Chữ ký',
    footer: 'Ghi chú cuối',
    preview: 'Xem trước',
  },
  fields: {
    paperSize: 'Cỡ giấy',
    logoUrl: 'URL Logo',
    tenCongTy: 'Tên công ty',
    dongDiaChi1: 'Dòng địa chỉ 1',
    dongDiaChi2: 'Dòng địa chỉ 2',
    hotline: 'Hotline',
    website: 'Website',
    tieuDeHoaDon: 'Tiêu đề mẫu',
    thongTinTrai: 'Cột thông tin trái',
    thongTinPhai: 'Cột thông tin phải',
    cot: 'Cột bảng hàng hóa',
    cotTieuDe: 'Tiêu đề cột',
    cotHienThi: 'Hiển thị',
    tongTienHangHienThi: 'Hiện dòng Tổng cộng',
    chietKhauHienThi: 'Hiện dòng Chiết khấu',
    tongThanhToanHienThi: 'Hiện dòng Tổng thanh toán',
    hienThiTongBangChu: 'Hiện tổng tiền bằng chữ',
    chuKy: 'Các ô chữ ký',
    chuKyTieuDe: 'Tiêu đề ô chữ ký',
    chuKyGhiChu: 'Ghi chú ô chữ ký',
    ngayThangNamLine: 'Dòng ngày tháng năm',
    ghiChuFooter: 'Ghi chú cuối trang',
    saveMauInName: 'Tên mẫu',
    saveMauInNamePlaceholderPdf: 'VD: Hóa đơn A4 chuẩn',
    saveMauInNamePlaceholderExcel: 'VD: Hóa đơn Excel kế toán',
    saveMauInPrivate: 'Chỉ mình tôi',
    saveMauInPublic: 'Chia sẻ',
  },
  studio: {
    paper: 'Giấy in',
    orientation: 'Hướng giấy',
    portrait: 'Dọc',
    landscape: 'Ngang',
    marginTop: 'Lề trên (mm)',
    marginRight: 'Lề phải (mm)',
    marginBottom: 'Lề dưới (mm)',
    marginLeft: 'Lề trái (mm)',
    appearance: 'Kiểu bảng',
    fontFamily: 'Phông chữ',
    tableHeaderBg: 'Màu nền tiêu đề cột',
    tableBorder: 'Màu viền bảng',
    zebra: 'Tô xen kẽ dòng',
    textStyle: 'Kiểu chữ',
    textColor: 'Màu chữ',
    textSection: {
      title: 'Tiêu đề',
      header: 'Đầu trang',
      tableHeader: 'Tiêu đề cột',
      tableBody: 'Nội dung bảng',
      signatures: 'Chữ ký',
      totals: 'Tổng cộng',
    },
    totalsRows: 'Dòng hiển thị',
    totalsLook: 'Kiểu khối tổng',
    totalsLayout: 'Kẻ bảng',
    totalsLayoutGrid: 'Kẻ ô',
    totalsLayoutLines: 'Kẻ ngang',
    totalsLayoutPlain: 'Không kẻ',
    totalsWidth: 'Độ rộng',
    totalsWidthFull: 'Toàn trang',
    totalsWidthRight: '{pct}% bên phải',
    totalsHighlightLast: 'Làm nổi bật dòng cuối (tổng thanh toán)',
    selectedColumns: 'Cột đã chọn',
    addColumn: 'Thêm cột',
    sampleData: 'Dữ liệu mẫu',
    viewSheet: 'Xem phiếu',
    editSheet: 'Chỉnh mẫu',
    previewSummary: '{rows} dòng · {cols} cột',
    blocks: 'Cấu trúc phiếu',
    addBlock: 'Thêm khối',
    addGroupBasic: 'Khối cơ bản',
    addGroupTable: 'Bảng & tổng tiền',
    addGroupPreset: 'Tổ chức nhanh',
    preset: {
      company: 'Thông tin công ty',
      signatures: 'Chữ ký',
      qrCode: 'QR mã chứng từ',
      trackingBarcode: 'Mã vạch vận đơn',
    },
    sheetTemplates: {
      open: 'Mẫu có sẵn',
      openHint: 'Chọn một mẫu dựng sẵn cho cả phiếu — giữ thông tin công ty, cột và chữ ký. Ctrl+Z để hoàn tác.',
      title: 'Mẫu in có sẵn',
      subtitle: 'Bấm một mẫu để áp cho cả phiếu. Thông tin công ty, cột bảng và chữ ký được giữ nguyên.',
      applyHover: 'Dùng mẫu này',
      applied: 'Đã áp dụng «{name}». Bấm Ctrl+Z nếu muốn quay lại.',
      defaultBadge: 'Mặc định',
      khoBadge: 'Chuẩn kho',
      items: {
        'kho-pgh-v1': {
          name: 'Phiếu giao hàng V1',
          desc: 'Mẫu vận hành kho: logo + địa chỉ, mã vận đơn, ảnh · vị trí · quy cách, tổng số kiện, chữ ký Thủ kho / Vận chuyển / Người nhận.',
        },
        'kho-pgh-v1-plain': {
          name: 'Phiếu giao hàng V1 · không logo',
          desc: 'Phiếu giao hàng V1 bỏ logo và địa chỉ chi nhánh.',
        },
        'kho-hd-v1': {
          name: 'Hóa đơn bán hàng V1',
          desc: 'Mẫu vận hành kho có giá bán, thành tiền, tổng thanh toán + bằng chữ, kèm logo + địa chỉ.',
        },
        'kho-hd-v1-plain': {
          name: 'Hóa đơn bán hàng V1 · không logo',
          desc: 'Hóa đơn bán hàng V1 bỏ logo và địa chỉ chi nhánh.',
        },
        'kho-pgh-v2': {
          name: 'Phiếu giao hàng V2',
          desc: 'Như V1, thêm cột kích thước kiện (cm) và cân nặng kiện (kg).',
        },
        'kho-pgh-v2-plain': {
          name: 'Phiếu giao hàng V2 · không logo',
          desc: 'Phiếu giao hàng V2 bỏ logo và địa chỉ chi nhánh.',
        },
        'kho-hd-v2': {
          name: 'Hóa đơn bán hàng V2',
          desc: 'Hóa đơn V1 thêm cột kích thước kiện và cân nặng kiện.',
        },
        'kho-hd-v2-plain': {
          name: 'Hóa đơn bán hàng V2 · không logo',
          desc: 'Hóa đơn bán hàng V2 bỏ logo và địa chỉ chi nhánh.',
        },
        'kho-logo': {
          name: 'Chuẩn kho · có logo',
          desc: 'Giống phiếu kho cũ: logo + địa chỉ, mã vạch, khung thông tin + QR, bảng kẻ xám, chữ ký 3 bên.',
        },
        'kho-plain': {
          name: 'Chuẩn kho · không logo',
          desc: 'Bản không logo, địa chỉ của phiếu kho — dùng cho giấy in sẵn tiêu đề công ty.',
        },
        'kho-a5': {
          name: 'Kho gọn · A5',
          desc: 'Phiếu kho thu gọn khổ A5: chữ nhỏ, mã vạch số phiếu, bỏ QR để vừa nửa tờ A4.',
        },
        modern: {
          name: 'Hiện đại',
          desc: 'Màu nhấn xanh đậm, tiêu đề lớn, bảng có nền tiêu đề và sọc xen kẽ.',
        },
        classic: {
          name: 'Cổ điển',
          desc: 'Font Times, đầu trang căn giữa gạch đôi, tổng tiền kẻ ngang — kiểu chứng từ kế toán.',
        },
      },
    },
    library: {
      open: 'Khối dựng sẵn',
      openHint: 'Chọn nhóm khối thiết kế sẵn (đầu trang, chân trang, chữ ký…) rồi chỉ cần sửa nhẹ',
      title: 'Thư viện khối dựng sẵn',
      subtitle: 'Bấm vào một mẫu để thêm vào phiếu. Sau khi thêm vẫn sửa chữ, logo, căn lề như khối thường.',
      more: 'Xem tất cả khối dựng sẵn…',
      insert: 'Thêm',
      insertHover: 'Thêm vào phiếu',
      emptyTitle: 'Phiếu đang trống',
      emptyHint: 'Bắt đầu nhanh bằng khối dựng sẵn: chọn một đầu trang, phần thông tin, chữ ký và chân trang.',
      filterLabel: 'Lọc:',
      noMatch: 'Không có khối nào khớp bộ lọc này.',
      filter: {
        all: 'Tất cả',
        logo: 'Có logo',
        noLogo: 'Không logo',
        qr: 'Có QR',
        tracking: 'Mã vận đơn',
      },
      tag: {
        logo: 'Logo',
        qr: 'QR',
        barcode: 'Mã vạch',
        tracking: 'Vận đơn',
      },
      placement: {
        top: 'Lên đầu phiếu',
        bottom: 'Xuống cuối phiếu',
        selected: 'Sau khối đang chọn',
        selectedInside: 'Vào nhóm đang chọn',
      },
      category: {
        all: 'Tất cả',
        header: 'Đầu trang',
        title: 'Tiêu đề phiếu',
        info: 'Thông tin',
        shipping: 'Vận chuyển',
        signature: 'Chữ ký',
        footer: 'Chân trang',
      },
      items: {
        'header-logo-left': { name: 'Logo trái + thông tin', desc: 'Logo bên trái, tên công ty, địa chỉ, hotline bên phải.' },
        'header-big-logo': { name: 'Logo lớn + địa chỉ', desc: 'Logo cỡ lớn bên trái, tên công ty chữ to — giống phiếu giao hàng kho.' },
        'header-centered': { name: 'Căn giữa có logo', desc: 'Logo, tên công ty và địa chỉ căn giữa, gạch chân phía dưới.' },
        'header-company-qr': { name: 'Logo + thông tin + QR', desc: 'Logo, thông tin công ty và mã QR chứng từ ở góc phải.' },
        'header-title-meta': { name: 'Logo + tiêu đề + số phiếu', desc: 'Logo, tiêu đề phiếu ở giữa, số phiếu và ngày in bên phải.' },
        'header-text-only': { name: 'Chỉ chữ (không logo)', desc: 'Tên công ty, địa chỉ bên trái; số phiếu, ngày in bên phải; gạch đậm.' },
        'header-minimal': { name: 'Tối giản 1 dòng', desc: 'Tên công ty và hotline trên cùng một dòng, gạch mảnh phía dưới.' },
        'header-text-qr': { name: 'Chữ + QR (không logo)', desc: 'Thông tin công ty bên trái, mã QR chứng từ bên phải.' },
        'title-center': { name: 'Tiêu đề căn giữa', desc: 'Tiêu đề lớn, số phiếu và dòng ngày tháng năm căn giữa.' },
        'title-meta-row': { name: 'Tiêu đề + dòng số phiếu', desc: 'Tiêu đề lớn, dưới là số phiếu bên trái và thời gian bên phải.' },
        'title-tracking-meta': { name: 'Tiêu đề + mã vận đơn', desc: 'Dòng Số HĐ · Mã vận đơn · Thời gian dưới tiêu đề — kiểu phiếu kho.' },
        'title-tracking-barcode': { name: 'Mã vạch vận đơn + tiêu đề', desc: 'Mã vạch vận đơn ở trên, tiêu đề và dòng Số HĐ · Mã vận đơn · Thời gian.' },
        'title-barcode': { name: 'Tiêu đề + mã vạch số phiếu', desc: 'Tiêu đề và ngày bên trái, mã vạch số phiếu bên phải.' },
        'title-qr-right': { name: 'Tiêu đề + QR', desc: 'Tiêu đề, số phiếu, ngày bên trái; mã QR chứng từ bên phải.' },
        'info-two-cols': { name: 'Thông tin 2 cột (nhãn liền)', desc: 'Các trường xếp 2 cột, giá trị nằm ngay sau nhãn «Nhãn: giá trị».' },
        'info-aligned-one-col': { name: 'Thông tin thẳng cột', desc: 'Nhãn một cột, giá trị một cột thẳng hàng — mỗi trường một dòng.' },
        'info-aligned-two-cols': { name: 'Thông tin 2 cột thẳng hàng', desc: 'Hai cột, mỗi bên nhãn và giá trị dóng thẳng nhau.' },
        'info-aligned-qr': { name: 'Thông tin thẳng cột + QR', desc: 'Nhãn / giá trị dóng thẳng bên trái, mã QR chứng từ bên phải.' },
        'info-aligned-recipient': { name: 'Khách hàng | Chứng từ', desc: 'Hai khối có tiêu đề: thông tin khách hàng và chứng từ, nhãn dóng thẳng.' },
        'info-one-col': { name: 'Thông tin 1 cột (nhãn liền)', desc: 'Mỗi trường một dòng, giá trị ngay sau nhãn — hợp khổ A5.' },
        'info-boxed': { name: 'Khung thông tin', desc: 'Toàn bộ thông tin trong một khung viền, nhãn in đậm.' },
        'info-boxed-two-cols': { name: 'Khung thông tin 2 cột', desc: 'Hai khung viền cạnh nhau, chia đôi các trường thông tin.' },
        'info-boxed-qr': { name: 'Khung thông tin + QR', desc: 'Khung thông tin bên trái, mã QR lớn bên phải — kiểu phiếu kho.' },
        'info-recipient-tracking': { name: 'Người nhận + mã vận đơn', desc: 'Khung người nhận (tên, SĐT, địa chỉ) và mã vạch vận đơn bên phải.' },
        'ship-tracking-barcode': { name: 'Mã vạch vận đơn lớn', desc: 'Mã vạch vận đơn cỡ lớn căn giữa, có in số bên dưới.' },
        'ship-tracking-qr': { name: 'Mã vạch vận đơn + QR', desc: 'Mã vận đơn và mã vạch bên trái, QR chứng từ bên phải.' },
        'ship-label': { name: 'Nhãn gửi hàng', desc: 'Khung Người gửi / Người nhận cạnh nhau, mã vạch vận đơn bên dưới.' },
        'ship-carrier-box': { name: 'Khung vận chuyển + QR vận đơn', desc: 'Mã vận đơn, số phiếu, ngày gửi, ghi chú giao; QR quét mã vận đơn.' },
        'signature-screen': { name: 'Chữ ký theo màn hình', desc: 'Các ô chữ ký mặc định của màn hình này, xếp ngang.' },
        'signature-received': { name: 'Ngày + Đã nhận đủ + chữ ký', desc: 'Ngày tháng năm, dòng «Đã nhận đủ» và các ô ký — kiểu phiếu kho.' },
        'signature-two': { name: 'Chữ ký 2 bên', desc: 'Người lập phiếu và Khách hàng, có dòng hướng dẫn ký.' },
        'signature-date-right': { name: 'Ngày + chữ ký bên phải', desc: 'Dòng ngày tháng năm và chữ ký người lập ở góc phải.' },
        'signature-confirm': { name: 'Cam kết + người nhận ký', desc: 'Câu xác nhận đã kiểm hàng bên trái, ô ký người nhận bên phải.' },
        'footer-thanks': { name: 'Lời cảm ơn', desc: 'Gạch đứt và câu cảm ơn căn giữa.' },
        'footer-notes': { name: 'Lưu ý khi nhận hàng', desc: 'Lưu ý khi nhận hàng / về đơn hàng và lời chúc — giống phiếu kho.' },
        'footer-contact': { name: 'Hotline + website', desc: 'Gạch ngang, hotline bên trái và website bên phải.' },
        'footer-qr-note': { name: 'QR + ghi chú', desc: 'Mã QR tra cứu kèm ghi chú cuối phiếu.' },
        'footer-tracking-lookup': { name: 'Tra cứu vận đơn + QR', desc: 'Hướng dẫn tra cứu, mã vận đơn, hotline và QR quét mã vận đơn.' },
        'footer-policy': { name: 'Chính sách đổi trả', desc: 'Khung chính sách đổi trả và giờ in phiếu.' },
      },
    },
    selectBlockHint: 'Chọn một khối để di chuyển, nhân bản, ẩn hoặc xóa',
    treeHideBlock: 'Ẩn khối (không in)',
    treeShowBlock: 'Hiện lại khối',
    treeCollapseAll: 'Thu gọn',
    treeExpandAll: 'Mở hết',
    treeCollapseGroup: 'Thu gọn nhóm',
    treeExpandGroup: 'Mở rộng nhóm',
    templates: 'Mẫu in',
    templatesCount: '{count} mẫu',
    clickToEdit: 'Bấm vào giấy để chọn khối · bấm lần nữa để sửa nội dung · Delete để xóa',
    showStructure: 'Hiện khung cấu trúc khối',
    hideStructure: 'Ẩn khung cấu trúc khối',
    structureHint: 'Viền nét đứt + nhãn tên trên từng khối để thấy bố cục. Tắt đi để xem giấy gọn như bản in.',
    blockChip: {
      page: 'Giấy',
    },
    undo: 'Hoàn tác',
    redo: 'Làm lại',
    clearAllBlocks: 'Xóa trắng',
    sheet: 'Trang tính',
    sheetEmptyHint:
      'Bấm ô để chọn, kéo chuột để chọn vùng, Shift+bấm hoặc Shift+phím mũi tên để mở rộng. Gộp ô / Bỏ gộp ở thanh xem trước. Gõ nội dung hoặc chèn biến ở khung bên phải.',
    sheetSelectionOne: 'Đang chọn {cell}',
    sheetSelectionRange: 'Đang chọn {from}:{to}',
    mergeCells: 'Gộp ô',
    mergeCellsHint: 'Kéo hoặc Shift+bấm để chọn vùng, rồi gộp thành một ô',
    unmergeCells: 'Bỏ gộp',
    unmergeCellsHint: 'Chọn ô đã gộp rồi bấm để tách lại từng ô',
    zoomIn: 'Phóng to',
    zoomOut: 'Thu nhỏ',
    zoomReset: 'Về 100%',
    fitWidth: 'Vừa chiều ngang (giấy to, cuộn dọc)',
    colResizeHint: 'Kéo để đổi độ rộng cột · Nhấp đúp để chia lại mặc định',
    fitPage: 'Xem trọn cả trang',
    undoShortcut: 'Hoàn tác (Ctrl+Z)',
    redoShortcut: 'Làm lại (Ctrl+Y)',
    saveShortcut: 'Lưu (Ctrl+S)',
    unsaved: 'Chưa lưu',
    resetStyle: 'Đặt lại kiểu chữ khối này',
    selectAll: 'Chọn hết',
    selectNone: 'Bỏ chọn',
    showBlock: 'Hiện khối này',
    blockName: 'Tên khối',
    infoBlankHint:
      'Từ giấy trắng: bật trường có sẵn bên dưới, hoặc thêm dòng chữ / dòng trường để nhập nội dung.',
    addInfoText: 'Thêm dòng chữ',
    addInfoFieldRow: 'Thêm dòng trường',
    addInfoField: 'Thêm trường có sẵn',
    addChildBlock: 'Thêm khối con',
    treeMoveIn: 'Đưa vào trong',
    treeMoveOut: 'Đưa ra ngoài',
    treeCopyBlock: 'Sao chép khối',
    treeCopySuffix: ' (bản sao)',
    treeMoveUp: 'Đưa lên',
    treeMoveDown: 'Đưa xuống',
    treeDeleteBlock: 'Xóa khối',
    blockKind: 'Loại khối',
    childrenLayout: 'Hướng xếp',
    childrenLayoutVertical: 'Dọc',
    childrenLayoutHorizontal: 'Ngang',
    childrenLayoutHint: 'Mặc định xếp khối con theo chiều dọc. Chọn Ngang để các khối con nằm cạnh nhau.',
    childrenWidth: 'Độ rộng khối con (mm)',
    childrenWidthHint: 'Nhập mm để cố định cột. Để trống = chiếm phần còn lại. Logo dùng rộng × cao cố định.',
    childrenWidthExcel: 'Độ rộng khối con (cột Excel)',
    childrenWidthHintExcel: 'Nhập số cột A, B, C… Để trống = chiếm phần còn lại trên cùng hàng.',
    blockWidthMm: 'Rộng khối (mm)',
    blockWidthCols: 'Rộng khối (cột)',
    excelLayout: 'Bố cục ô Excel',
    excelLayoutHint: 'Nhập cột bắt đầu (1 = A) và số lượng cột. VD: bắt đầu 1, số cột 4 = A→D.',
    excelColStart: 'Cột bắt đầu',
    excelColCount: 'Số lượng cột',
    excelColEnd: 'Cột kết thúc',
    excelColEndAuto: 'Hết hàng (tự động)',
    excelRowHeightPt: 'Chiều cao dòng',
    excelRowHeightHint: 'Cùng đơn vị với Excel (Format → Chiều cao dòng). Để trống = tự theo nội dung. Mặc định Excel ~15.',
    infoNestHint:
      'Chọn khối này rồi bấm «Thêm khối con» để gắn văn bản / dòng trường / … bên trong (giống YTL). Có thể lồng nhiều cấp.',
    align: 'Căn lề',
    alignLeft: 'Trái',
    alignCenter: 'Giữa',
    alignRight: 'Phải',
    bold: 'In đậm',
    italic: 'In nghiêng',
    underline: 'Gạch chân',
    fontSize: 'Cỡ chữ (pt)',
    textContent: 'Nội dung',
    textVarsHint: 'Gõ chữ cố định, bấm «Chèn biến» để thêm dữ liệu của phiếu.',
    insertVar: 'Chèn biến',
    varTextPlaceholder: 'Nhập chữ…',
    varGroupCommon: 'Chung',
    varGroupInfo: 'Thông tin phiếu',
    varGroupColumns: 'Cột bảng',
    varGroupExtra: 'Khác',
    varDay: 'Ngày',
    varMonth: 'Tháng',
    varYear: 'Năm',
    varAmountInWords: 'Số tiền bằng chữ',
    textCase: 'Kiểu chữ hoa/thường',
    textCaseNone: 'Giữ nguyên',
    textCaseUpper: 'IN HOA',
    textCaseLower: 'in thường',
    textCaseSentence: 'Viết hoa đầu câu',
    marginTopMm: 'Cách trên (mm)',
    marginBottomMm: 'Cách dưới (mm)',
    logoWidth: 'Rộng logo (mm)',
    logoWidthCols: 'Rộng logo (cột)',
    logoHeight: 'Cao logo (mm)',
    logoImage: 'Ảnh logo',
    logoChoose: 'Chọn ảnh',
    logoPaste: 'Dán ảnh',
    logoDragDrop: 'Kéo ảnh vào đây',
    logoPasteHint: 'Hoặc dán ảnh / link http(s)',
    logoFit: 'Cách hiển thị ảnh',
    logoFitContain: 'Vừa khung, giữ tỉ lệ',
    logoFitCover: 'Lấp đầy, cắt bớt mép',
    logoFitFill: 'Kéo giãn kín khung',
    barcodeField: 'Nội dung mã',
    barcodeCode: 'Mã chứng từ',
    qrSizeMm: 'Cạnh QR (mm)',
    barcodeHeightMm: 'Cao vạch (mm)',
    codeShowText: 'In chữ bên dưới mã',
    qrHint: 'Quét bằng điện thoại / máy quét ra đúng nội dung. Phiếu không có dữ liệu thì khối tự ẩn.',
    barcodeHint:
      'Mã vạch Code 128 — chỉ chữ không dấu và số. Hóa đơn chưa có mã vận đơn (chưa tạo vận đơn) thì khối tự ẩn.',
    todayVar: 'Ngày hôm nay',
    fieldKey: 'Trường dữ liệu',
    fieldLabel: 'Nhãn dòng',
    labelWidthPct: 'Rộng nhãn (%)',
    valueWidthPct: 'Rộng giá trị (%)',
    labelWidthMm: 'Rộng nhãn (mm)',
    labelWidthAuto: 'Tự động',
    labelWidthApply: 'Áp dụng cả nhóm',
    labelWidthApplyHint:
      'Đặt cùng độ rộng nhãn cho mọi dòng có nhãn trong nhóm này để giá trị thẳng cột. Để trống = nhãn sát giá trị.',
    colorNone: 'Không màu',
    colorCustom: 'Chọn màu khác',
    sectionFrame: 'Khung & nền',
    frameNone: 'Không',
    frameSolid: 'Liền',
    frameDashed: 'Đứt',
    frameDotted: 'Chấm',
    frameColor: 'Màu khung',
    fillColor: 'Màu nền',
    paddingMm: 'Đệm trong (mm)',
    childGapMm: 'Cách giữa khối con (mm)',
    childGapDefault: 'Mặc định',
    childAlign: 'Căn dọc',
    childAlignTop: 'Căn trên',
    childAlignCenter: 'Căn giữa',
    childAlignBottom: 'Căn dưới',
    tableHeaderBgShort: 'Nền tiêu đề',
    tableBorderShort: 'Viền bảng',
    tableZebraBgShort: 'Dòng xen kẽ',
    pageMargins: 'Lề giấy (mm)',
    marginsLink: 'Đặt đều 4 lề',
    marginsUnlink: 'Chỉnh riêng từng lề',
    marginTopShort2: 'Trên',
    marginRightShort: 'Phải',
    marginBottomShort2: 'Dưới',
    marginLeftShort: 'Trái',
    labelWidthCols: 'Số cột nhãn',
    labelWidthColsHint: 'Phần cột còn lại trong khối là giá trị.',
    dividerStyle: 'Kiểu',
    dividerSolid: 'Đường nét liền',
    dividerDashed: 'Đường nét đứt',
    dividerDotted: 'Đường nét chấm',
    dividerSpace: 'Chỉ khoảng trống',
    sectionContent: 'Nội dung',
    sectionArrange: 'Bố cục khối con',
    sectionFormat: 'Định dạng chữ',
    sectionSize: 'Kích thước',
    sectionLayout: 'Vị trí & khoảng cách',
    fontSizeShort: 'Cỡ chữ',
    textCaseShort: 'Hoa / thường',
    colorShort: 'Màu',
    dividerWidthShort: 'Độ dày (pt)',
    widthMmShort: 'Rộng (mm)',
    heightMmShort: 'Cao (mm)',
    widthColsShort: 'Rộng (cột)',
    marginTopShort: 'Cách trên (mm)',
    marginBottomShort: 'Cách dưới (mm)',
    autoWidth: 'Tự động',
    textLabel: 'Nhãn (tuỳ chọn)',
    textBody: 'Chữ & biến dữ liệu',
    stylePart_value: 'Kiểu giá trị biến',
    stylePartReset: 'Đặt lại kiểu',
    textLabelPlaceholder: 'VD: Khách hàng → in «Khách hàng: …»',
    dividerWidth: 'Độ dày đường kẻ (pt)',
    dividerColor: 'Màu đường kẻ',
    spacerHeight: 'Chiều cao khoảng trống (mm)',
    noteBorder: 'Kẻ khung quanh',
    blockGap: 'Khoảng cách khối (mm)',
    lineHeight: 'Giãn dòng',
    accentColor: 'Màu nhấn',
    tableZebraBg: 'Màu dòng xen kẽ',
    tableCellPadding: 'Padding ô (pt)',
    formulas: 'Cột công thức',
    addFormula: 'Thêm cột công thức',
    formulaLabel: 'Tên cột',
    addTerm: 'Thêm hạng tử',
    termOp: 'Toán tử',
    termKind: 'Nguồn',
    termField: 'Cột',
    termNumber: 'Hằng số',
    termKindField: 'Cột dữ liệu',
    termKindNumber: 'Hằng số',
    formulaPreview: 'Công thức',
    kind: {
      group: 'Nhóm khối',
      table: 'Bảng dữ liệu',
      totals: 'Tổng cộng',
      text: 'Văn bản',
      variable: 'Biến dữ liệu',
      fieldRow: 'Dòng trường',
      divider: 'Đường kẻ',
      spacer: 'Khoảng trống',
      note: 'Ghi chú khung',
      logo: 'Logo',
      barcode: 'Mã vạch',
      qrcode: 'Mã QR',
      clone: 'Bản sao',
    },
    family: {
      text: 'Văn bản / dữ liệu',
      group: 'Nhóm khối',
      logo: 'Logo / ảnh',
      code: 'Mã QR / mã vạch',
      line: 'Đường kẻ / khoảng trống',
      table: 'Bảng dữ liệu',
      totals: 'Tổng cộng',
    },
    familyHint: {
      text: 'Chữ cố định, chèn biến, có nhãn hoặc khung',
      group: 'Chứa khối con, xếp dọc hoặc ngang',
      logo: 'Ảnh logo chi nhánh hoặc ảnh tải lên',
      code: 'QR / Code 128 theo mã chứng từ, mã vận đơn…',
      line: 'Đường kẻ ngang hoặc khoảng cách trống',
      table: 'Danh sách hàng hoá, kéo được độ rộng cột',
      totals: 'Tổng tiền, chiết khấu, bằng chữ',
    },
    block: {
      page: 'Giấy / lề',
      title: 'Tiêu đề',
      header: 'Đầu trang',
      info: 'Thông tin chứng từ',
      table: 'Bảng dữ liệu',
      totals: 'Tổng cộng',
      date: 'Ngày tháng',
      signatures: 'Chữ ký',
      footer: 'Ghi chú cuối',
    },
  },
  excel: {
    infoRows: 'Dòng thông tin',
    showCustomer: 'Khách hàng',
    showInvoiceNo: 'Số hóa đơn',
    showPhone: 'Số điện thoại',
    showBranch: 'Chi nhánh',
    showAddress: 'Địa chỉ',
    showSeller: 'Nhân viên bán hàng',
    showNote: 'Ghi chú',
    showTotals: 'Tổng tiền',
    showAmountInWords: 'Tổng bằng chữ',
    columnOrder: 'Thứ tự / tên cột',
    tableHeaderBg: 'Màu nền tiêu đề cột',
    columnDetail: 'Chi tiết cột',
    columnWidth: 'Độ rộng',
    columnHint: 'Độ rộng theo ký tự Excel. Kéo mép cột A, B, C trên xem trước để chỉnh nhanh.',
    resizeHint: 'Kéo mép tiêu đề cột để đổi độ rộng',
    emptyPreview: 'Chưa có khối — thêm khối ở cột cấu trúc để xem trước.',
    fmt: {
      bold: 'In đậm (Ctrl+B)',
      italic: 'In nghiêng (Ctrl+I)',
      underline: 'Gạch chân (Ctrl+U)',
      alignLeft: 'Căn trái',
      alignCenter: 'Căn giữa',
      alignRight: 'Căn phải',
      fontSize: 'Cỡ chữ',
      textColor: 'Màu chữ',
      fillColor: 'Màu nền ô',
      noTarget: 'Chọn một ô có nội dung hoặc một cột của bảng để định dạng',
      columnOnly: 'Cột bảng chỉ chỉnh được đậm và căn lề',
    },
    formulaBar: {
      readOnly: 'Ô này lấy dữ liệu tự động — sửa ở bảng thuộc tính bên trái',
      placeholder: 'Nhập nội dung ô… dùng {bien} để chèn dữ liệu',
      empty: 'Chọn một ô để xem / sửa nội dung',
    },
    sheet: {
      open: 'Thiết lập sheet',
      title: 'Thiết lập file Excel',
      sheetName: 'Tên sheet',
      sheetNamePlaceholder: 'Mặc định: {name}',
      fileName: 'Tên file',
      fileNameHint: 'Dùng {code} = mã chứng từ, {ngay} = ngày xuất',
      page: 'Trang in',
      paper: 'Khổ giấy',
      portrait: 'Dọc',
      landscape: 'Ngang',
      fitWidth: 'Vừa 1 trang theo chiều ngang',
      repeatHeader: 'Lặp tiêu đề bảng ở mỗi trang in',
      view: 'Hiển thị',
      freezeHeader: 'Cố định dòng tiêu đề bảng khi cuộn',
      gridLines: 'Hiện đường lưới Excel',
      autoFilter: 'Bật lọc (AutoFilter) ở tiêu đề bảng',
      zebra: 'Tô xen kẽ dòng bảng hàng',
      borders: 'Kẻ viền',
      bordersTable: 'Bảng & khung',
      bordersAll: 'Mọi ô',
      bordersNone: 'Không',
      numberFormat: 'Cột số',
      numberInt: '1,234',
      numberDec2: '1,234.00',
      numberText: 'Giữ dạng chữ',
      numberHint: 'Dạng số giúp cộng / lọc được ngay trong Excel.',
    },
  },
  copy: {
    title: 'Nhân bản / copy mẫu in',
    suffix: 'bản sao',
    name: 'Tên bản sao',
    targetScreen: 'Màn hình đích',
    sameKindPdf: 'Chỉ copy sang mẫu PDF của màn khác.',
    sameKindExcel: 'Chỉ copy sang mẫu Excel của màn khác.',
    targetProjects: 'Dự án đích',
    selectAll: 'Chọn tất cả ({n} dự án)',
    current: 'hiện tại',
    onlyCurrentProject: 'Bản sao sẽ được tạo trong dự án hiện tại.',
    keepPublic: 'Mẫu gốc là mẫu chung → bản sao cũng là mẫu chung (mọi người trong dự án đích dùng được).',
    keepPrivate: 'Mẫu gốc là mẫu riêng → bản sao là mẫu riêng của bạn.',
    submit: 'Tạo {n} bản sao',
    success: 'Đã tạo {n} bản sao mẫu in.',
    skipped: 'Bỏ qua {n} dự án bạn không có quyền.',
    needName: 'Nhập tên bản sao.',
    needProject: 'Chọn ít nhất 1 dự án đích.',
    loadProjectsError: 'Không tải được danh sách dự án.',
    saveError: 'Không sao chép được mẫu in. Vui lòng thử lại.',
  },
  actions: {
    save: 'Lưu mẫu in',
    resetDefault: 'Đặt lại mặc định',
    printTest: 'In thử',
    exportExcelTest: 'Xuất Excel thử',
    insertPlaceholder: 'Chèn biến',
    addLine: 'Thêm dòng',
    removeLine: 'Xóa dòng',
    addChuKy: 'Thêm ô chữ ký',
    removeChuKy: 'Xóa ô chữ ký',
    mauInCreateNew: 'Tạo mẫu mới',
    deleteMauIn: 'Xóa mẫu in',
    copyMauIn: 'Nhân bản / copy mẫu in',
    saveMauIn: 'Lưu mẫu',
    updateMauIn: 'Cập nhật mẫu',
    saveAs: 'Lưu thành mẫu mới',
    saveAsHint: 'Giữ nguyên mẫu đang sửa, lưu bản chỉnh này thành một mẫu khác',
    discardChanges: 'Bỏ thay đổi',
    discardChangesHint: 'Quay về lần lưu gần nhất. Lỡ tay thì bấm Hoàn tác (Ctrl+Z) để lấy lại.',
    rebuildDefaultLayout: 'Dựng lại mẫu gốc',
    rebuildDefaultLayoutHint:
      'Thay toàn bộ bố cục bằng mẫu chuẩn của màn hình này. Chưa lưu cho tới khi bấm Lưu; có thể Hoàn tác (Ctrl+Z).',
    discardAndContinue: 'Bỏ thay đổi và tiếp tục',
  },
  messages: {
    loadError: 'Không tải được mẫu in.',
    saveSuccess: 'Đã lưu mẫu in.',
    saveError: 'Lưu mẫu in thất bại.',
    resetSuccess: 'Đã đặt lại mặc định.',
    resetConfirm: 'Đặt lại mẫu in về mặc định? Mọi thay đổi sẽ mất.',
    isDefault: 'Đang dùng mẫu mặc định',
    isCustom: 'Đã tùy chỉnh',
    noMauInPdf: 'Chưa có mẫu in PDF',
    noMauInExcel: 'Chưa có mẫu Excel',
    mauInInvalid: 'Mẫu in không hợp lệ hoặc thiếu cấu hình',
    mauInPublicBadge: 'Mẫu chung',
    mauInReorderHint: 'Kéo thả để sắp xếp — thứ tự áp dụng cho danh sách mẫu khi in.',
    mauInReorderFailed: 'Không lưu được thứ tự mẫu in. Vui lòng thử lại.',
    mauInDeleteTitle: 'Xóa mẫu in',
    mauInDeleteConfirm: 'Xóa mẫu "{name}"? Mẫu sẽ không còn hiện trong danh sách chọn mẫu khi in.',
    mauInDeleted: 'Đã xóa mẫu "{name}".',
    mauInDeleteFailed: 'Không xóa được mẫu in. Vui lòng thử lại.',
    noEditPermission: 'Tài khoản chưa được cấp chức năng "Sửa mẫu in" — chỉ xem và in thử.',
    mauInKindTitle: 'Loại mẫu',
    mauInListTitle: 'Mẫu có sẵn ({count})',
    mauInDraftNew: 'Mẫu mới (chưa lưu)',
    saveMauInNameRequired: 'Nhập tên mẫu in',
    saveMauInSuccess: 'Đã lưu mẫu in lên server',
    updateMauInSuccess: 'Đã cập nhật mẫu in',
    selectMauInRequired: 'Chọn mẫu in trước khi xuất',
    unsavedTitle: 'Mẫu in chưa được lưu',
    unsavedConfirm: 'Bạn có thay đổi chưa lưu. Nếu tiếp tục, các thay đổi này sẽ mất.',
  },
  placeholders: {
    help:
      'Dùng {Ten_Bien} để chèn dữ liệu động. Vd: {Ma_Don_Hang}, {Khach_Hang}, {Tong_Cong}.',
  },
  v2: {
    pageBreak: 'Ngắt trang',
    hints: {
      lineVarOutsideRepeat: 'Không chèn được: biến dòng hàng hóa chỉ đặt trong dòng bảng "Lặp theo hàng hóa". Đặt con trỏ vào dòng đó rồi chèn lại.',
      totalVarOutsideRepeat: 'Không chèn được: biến dòng tổng chỉ đặt trong dòng bảng "Lặp theo dòng tổng". Đặt con trỏ vào dòng đó rồi chèn lại.',
      groupVarOutsideRepeat:
        'Không chèn được: biến hàng sửa chữa chỉ đặt trong khối "Lặp theo hàng sửa" (Khối hàng SC). Đặt con trỏ vào khối đó rồi chèn lại.',
    },
    messages: {
      uploadError: 'Tải ảnh lên thất bại',
    },
    canvas: {
      showSample: 'Hiện dữ liệu mẫu',
    },
    toolbar: {
      undo: 'Hoàn tác (Ctrl+Z)',
      redo: 'Làm lại (Ctrl+Y)',
      block: 'Kiểu đoạn',
      blockNormal: 'Văn bản',
      blockH1: 'Tiêu đề 1',
      blockH2: 'Tiêu đề 2',
      blockH3: 'Tiêu đề 3',
      font: 'Phông chữ',
      fontDefault: 'Mặc định',
      fontSize: 'Cỡ chữ (pt)',
      bold: 'In đậm (Ctrl+B)',
      italic: 'In nghiêng (Ctrl+I)',
      underline: 'Gạch chân (Ctrl+U)',
      strike: 'Gạch ngang',
      color: 'Màu chữ',
      highlight: 'Màu nền chữ',
      clearColor: 'Bỏ màu',
      clearFormat: 'Xóa định dạng',
      align: {
        left: 'Căn trái',
        center: 'Căn giữa',
        right: 'Căn phải',
        justify: 'Căn đều',
      },
      bulletList: 'Danh sách dấu chấm',
      orderedList: 'Danh sách số',
      insert: 'Chèn',
      table: 'Bảng',
      linesTable: 'Bảng hàng hóa',
      linesTableHint: 'Chèn bảng hàng hóa: dòng tiêu đề + dòng lặp theo từng mặt hàng',
      repairGroups: 'Khối hàng SC',
      repairGroupsHint:
        'Chèn khối lặp theo từng hàng sửa chữa (1 HĐ → nhiều HH), mỗi khối có bảng hàng thay thế / dịch vụ',
      totalsTable: 'Bảng tổng',
      totalsTableHint: 'Chèn bảng tổng tiền (lặp theo các dòng tổng của phiếu)',
      signatures: 'Chữ ký',
      logo: 'Logo',
      logoHint: 'Chèn logo chi nhánh — tự lấy logo của chi nhánh khi in',
      image: 'Ảnh',
      uploading: 'Đang tải…',
      qr: 'Mã QR',
      barcode: 'Mã vạch',
      hr: 'Đường kẻ ngang',
      pageBreak: 'Ngắt trang',
    },
    table: {
      title: 'Bảng',
      rowAbove: 'Chèn dòng phía trên',
      rowBelow: 'Chèn dòng phía dưới',
      colLeft: 'Chèn cột bên trái',
      colRight: 'Chèn cột bên phải',
      addRow: 'Dòng',
      addCol: 'Cột',
      above: 'Trên',
      below: 'Dưới',
      left: 'Trái',
      right: 'Phải',
      headerRow: 'Tiêu đề',
      delete: 'Xóa',
      merge: 'Gộp ô',
      split: 'Tách ô',
      deleteRow: 'Xóa dòng',
      deleteCol: 'Xóa cột',
      deleteTable: 'Xóa bảng',
      borders: 'Viền bảng',
      bordersAll: 'Viền liền',
      bordersDashed: 'Viền nét đứt',
      bordersNone: 'Không viền',
      repeat: 'Dòng này',
      repeatNone: 'Dòng thường',
      repeatLines: 'Lặp theo hàng hóa',
      repeatTotals: 'Lặp theo dòng tổng',
      repeatHint: 'Dòng lặp được nhân bản khi in — mỗi mặt hàng (hoặc mỗi dòng tổng) một dòng. Đặt biến "Dòng hàng hóa" vào dòng này.',
      vAlign: 'Căn dọc ô',
      vTop: 'Trên',
      vMiddle: 'Giữa',
      vBottom: 'Dưới',
      cellBg: 'Nền ô',
      toggleHeaderRow: 'Bật / tắt dòng tiêu đề',
      resizeHint: 'Kéo đường kẻ dọc để đổi độ rộng cột (bảng giữ nguyên bề rộng), nhấp đúp để chia đều 2 cột. Bôi đen nhiều ô để gộp.',
    },
    vars: {
      title: 'Trường dữ liệu',
      search: 'Tìm trường…',
      groups: {
        info: 'Thông tin phiếu',
        general: 'Chung',
        line: 'Dòng hàng hóa',
        total: 'Dòng tổng',
      },
      sections: {
        group: 'Hàng sửa chữa (nhóm)',
        line: 'Hàng thay thế / dịch vụ (từng dòng)',
        voucher: 'Thông tin phiếu',
        customer: 'Khách hàng',
        staff: 'Cửa hàng & nhân viên',
        money: 'Tiền & thanh toán',
        delivery: 'Giao hàng & đóng gói',
        repair: 'Yêu cầu sửa chữa',
        code: 'Mã vận đơn / QR',
        general: 'Ngày giờ & chung',
        total: 'Dòng tổng',
      },
      groupHints: {
        group: 'Đặt trong khối "Lặp theo hàng sửa" (1 hóa đơn → nhiều hàng sửa).',
        line: 'Đặt trong dòng bảng "Lặp theo hàng hóa" (trong từng hàng sửa: nhiều hàng thay thế).',
        total: 'Đặt trong dòng bảng "Lặp theo dòng tổng".',
      },
    },
    props: {
      qrTitle: 'Mã QR',
      barcodeTitle: 'Mã vạch',
      codeType: 'Loại mã',
      codeSource: 'Dữ liệu',
      codeCustom: 'Tùy chỉnh…',
      codeCustomPlaceholder: 'Vd: {code} hoặc https://…',
      codeCustomHelp: 'Có thể ghép chữ và biến, vd. https://shop.vn/don/{code}',
      qrSize: 'Kích thước',
      barcodeHeight: 'Chiều cao',
      barcodeWidth: 'Chiều rộng',
      auto: 'Tự động',
      codeShowText: 'Hiện chữ dưới mã',
      resizeHint: 'Kéo các nút ở góc / cạnh để đổi kích thước.',
      logoTitle: 'Logo chi nhánh',
      imageTitle: 'Ảnh',
      imageWidth: 'Chiều rộng',
      logoHint: 'Khi in sẽ tự lấy logo của chi nhánh (Cài đặt → Logo mẫu in).',
    },
    page: {
      title: 'Trang giấy',
      paper: 'Khổ giấy',
      orientation: 'Hướng',
      portrait: 'Dọc',
      landscape: 'Ngang',
      margins: 'Lề trang',
      top: 'Trên',
      bottom: 'Dưới',
      left: 'Trái',
      right: 'Phải',
      font: 'Phông mặc định',
      fontSize: 'Cỡ chữ',
      lineHeight: 'Giãn dòng',
      soBan: 'Số bản in',
      soBanUnit: 'bản',
      soBanHint: 'Mỗi lần in tự ra đủ số bản, mỗi bản bắt đầu ở trang mới.',
      soTrang: 'Đánh số trang',
      soTrangNone: 'Không đánh số',
      soTrangLeft: 'Chân trang · trái',
      soTrangCenter: 'Chân trang · giữa',
      soTrangRight: 'Chân trang · phải',
      soTrangHint: '"Trang x/y" nằm trong lề dưới — nên để lề dưới từ 10 mm.',
    },
  },
  xv2: {
    exporting: 'Đang xuất…',
    formula: {
      placeholder: 'Nội dung ô — gõ chữ, chèn biến dạng {code}, bắt đầu bằng = để tính (vd. ={tongCong}+{thuKhac})',
      help:
        'Công thức: bắt đầu ô bằng = (vd. =4+5+6 → 15, ={tongCong}-{giamGia}) hoặc chèn {= ... } giữa chữ.\n' +
        'Phép tính: + - * / ^ %, nối chuỗi bằng & (vd. ={customer} & " - " & {phone}), so sánh = <> < > <= >=.\n' +
        'Hàm: SUM, ROUND, ROUNDUP, ROUNDDOWN, MIN, MAX, ABS, AVERAGE, IF, AND, OR, NOT, CONCAT, UPPER, LOWER, TRIM, LEN, LEFT, RIGHT, TEXT(x; số lẻ), BANGCHU(x).\n' +
        'Biến không cần nằm trong ô nào. Bật "Hiện dữ liệu mẫu" để xem kết quả; công thức sai hiện #LỖI.',
    },
    hints: {
      lineVarOutsideRepeat: 'Không chèn được: biến dòng hàng hóa chỉ đặt trong dòng "Lặp theo hàng hóa" (chuột phải → Dòng lặp).',
      totalVarOutsideRepeat: 'Không chèn được: biến dòng tổng chỉ đặt trong dòng "Lặp theo dòng tổng" (chuột phải → Dòng lặp).',
    },
    messages: {
      exportError: 'Xuất file Excel thất bại',
      imagesMissing: 'Không tải được {n} logo/ảnh (proxy ảnh của máy chủ không phản hồi) — file Excel đã xuất nhưng thiếu ảnh.',
    },
    toolbar: {
      fill: 'Màu nền ô',
      v: {
        top: 'Căn trên',
        middle: 'Căn giữa dọc',
        bottom: 'Căn dưới',
      },
      wrap: 'Xuống dòng trong ô',
      borderOn: 'Kẻ viền ô',
      borderOff: 'Bỏ viền ô',
      merge: 'Gộp ô',
      mergeHint: 'Gộp các ô đang chọn thành một ô',
      unmerge: 'Bỏ gộp ô',
      linesTableHint: 'Chèn bảng hàng hóa tại ô đang chọn: dòng tiêu đề + dòng lặp theo từng mặt hàng',
      totalsRow: 'Dòng tổng',
      totalsRowHint: 'Chèn dòng tổng tiền (lặp theo các dòng tổng của phiếu)',
      rowRepeat: 'Dòng',
      rowRepeatHint: 'Dòng lặp được nhân bản khi xuất — mỗi mặt hàng / mỗi dòng tổng một dòng',
    },
    vars: {
      colField: 'Trường',
      colSample: 'Dữ liệu mẫu',
      empty: 'Không có trường phù hợp',
      groupHints: {
        line: 'Đặt trong dòng "Lặp theo hàng hóa".',
        total: 'Đặt trong dòng "Lặp theo dòng tổng".',
      },
    },
    grid: {
      insertRowAbove: 'Chèn {n} dòng phía trên',
      insertRowBelow: 'Chèn {n} dòng phía dưới',
      insertColLeft: 'Chèn {n} cột bên trái',
      insertColRight: 'Chèn {n} cột bên phải',
      deleteRows: 'Xóa {n} dòng',
      deleteCols: 'Xóa {n} cột',
      merge: 'Gộp ô',
      unmerge: 'Bỏ gộp ô',
      clear: 'Xóa nội dung',
      repeatLines: 'Dòng lặp theo hàng hóa',
      repeatTotals: 'Dòng lặp theo dòng tổng',
      repeatNone: 'Bỏ dòng lặp',
      repeatLinesHint: 'Dòng lặp theo hàng hóa — mỗi mặt hàng một dòng khi xuất',
      repeatTotalsHint: 'Dòng lặp theo dòng tổng — mỗi dòng tổng một dòng khi xuất',
      logoPlaceholder: 'LOGO',
      widthBadge: 'Rộng: {w} ({px} px)',
      heightBadge: 'Cao: {h} pt ({px} px)',
      colGripHint: 'Kéo để đổi độ rộng cột · nhấp đúp để vừa nội dung',
      rowGripHint: 'Kéo để đổi chiều cao dòng · nhấp đúp để về mặc định',
    },
    props: {
      width: 'Rộng',
      height: 'Cao',
      objectHint: 'Neo tại ô {cell}. Kéo để di chuyển, kéo nút ở góc / cạnh để đổi cỡ, phím mũi tên để dịch từng chút.',
      replaceImage: 'Đổi ảnh',
      deleteObject: 'Xóa',
    },
    cell: {
      title: 'Ô {range}',
      repeatHint: 'Dòng lặp được nhân bản khi xuất — đặt biến "Dòng hàng hóa" / "Dòng tổng" vào dòng này.',
      colWidth: 'Rộng cột',
      rowHeight: 'Cao dòng',
      hint: 'Nhấp đúp hoặc gõ phím để sửa ô · Enter / Tab để sang ô kế · Alt+Enter xuống dòng · chuột phải để chèn / xóa dòng, cột.',
    },
    sheet: {
      title: 'Trang tính',
      sheetName: 'Tên sheet',
      fileName: 'Tên file',
      fileNameHint: 'Hỗ trợ {code} (mã phiếu), {ngay} (ngày xuất).',
      groupFile: 'Tệp xuất',
      groupPage: 'Trang in',
      groupFont: 'Chữ mặc định',
      fitWidth: 'In vừa 1 trang ngang',
      gridLines: 'Hiện đường lưới trong Excel',
      freezeRows: 'Cố định số dòng đầu',
    },
  },
  formulaDialog: {
    title: 'Tạo công thức',
    open: 'Công thức',
    openHint: 'Tạo công thức tính số / nối chữ từ các biến (có xem trước kết quả)',
    editHint: 'Đang sửa công thức của ô / đoạn đang chọn',
    vars: 'Biến dữ liệu',
    varsHint: 'Bấm để chèn vào vị trí con trỏ trong công thức.',
    search: 'Tìm biến…',
    operators: 'Phép tính',
    functions: 'Hàm hay dùng',
    formula: 'Công thức',
    placeholder: 'Vd. {tongCong} + {thuKhac}   hoặc   {customer} & " - " & {phone}',
    readable: 'Đọc là',
    result: 'Kết quả với dữ liệu mẫu',
    resultEmpty: 'Chọn biến và phép tính ở trên để bắt đầu',
    resultBlank: '(rỗng)',
    error: 'Lỗi',
    insertAsExcel: 'Sẽ ghi vào ô',
    insertAsPdf: 'Sẽ chèn vào mẫu',
    examples: 'Ví dụ (bấm để dùng)',
    exampleLabels: {
      add: 'Cộng 2 số',
      mul: 'Tính 10%',
      join: 'Nối 2 chữ',
      bangchu: 'Số tiền bằng chữ',
    },
    ops: {
      add: 'Cộng số. Nếu một bên là chữ thì nối chữ',
      addShort: 'Cộng',
      sub: 'Trừ',
      subShort: 'Trừ',
      mul: 'Nhân (viết 10% = 0,1)',
      mulShort: 'Nhân',
      div: 'Chia',
      divShort: 'Chia',
      paren: 'Ngoặc — tính phần trong ngoặc trước',
      parenShort: 'Ngoặc',
      join: 'Nối chữ: ghép giá trị liền nhau, không cộng số',
      joinShort: 'Nối chữ',
      space: 'Nối kèm một khoảng trắng ở giữa',
      spaceShort: 'Nối + cách',
      text: 'Chữ cố định — gõ chữ vào giữa hai dấu nháy',
      textShort: 'Chữ',
    },
    fns: {
      sum: 'SUM(a; b; …) — tổng các số',
      round: 'ROUND(số; số lẻ) — làm tròn',
      if: 'IF(điều kiện; khi đúng; khi sai) — vd. IF({giamGia} > 0; "Có giảm"; "")',
      text: 'TEXT(số; số lẻ) — số có phân cách nghìn',
      bangchu: 'BANGCHU(số) — số tiền bằng chữ',
      upper: 'UPPER(chữ) — viết hoa',
    },
    help:
      '• + − × ÷ để tính số; & để nối chữ (giữ nguyên "0123", không cộng).\n' +
      '• Chữ cố định đặt trong dấu nháy: "Tổng: " & {tongCong}.\n' +
      '• Số nghìn viết 1000 hoặc 1.000; số lẻ viết 1.5. Ngăn cách tham số hàm bằng ; hoặc ,\n' +
      '• Excel: ghi cả ô dạng =công thức. PDF: chèn {= công thức } vào đoạn văn, bật "Xem trước" để thấy kết quả.',
    cancel: 'Hủy',
    apply: 'Chèn công thức',
  },
}
